import React from 'react';

import { useSelector } from 'react-redux';

import Icons from 'consts/icons';
import USpaceTable from './uspace/USpaceTable';
import { SidebarMenuDetailsUseStyles } from './SidebarMenuDetailsUseStyles';

const SidebarMenuUSpaceDetails = () => {
  const [items, setItems] = React.useState([]);
  const [checkItem, setCheckItem] = React.useState({
    operations: true,
    missions: true,
  });
  const [displayTable, setDisplayTable] = React.useState(true);
  const classes = SidebarMenuDetailsUseStyles();

  const useString = () => {
    const lang = useSelector(state => state.language);

    return lang;
  };
  const subtitles = useString().sidebar.uspace;

  React.useEffect(() => {
    setItems([
      {
        name: 'operations',
        icon: <Icons.Dashboard.Airplane />,
      },
      {
        name: 'missions',
        icon: <Icons.Dashboard.MissionApprovals />,
      },
    ]);
  }, []);

  const toggleCheck = (name, check) => {
    setCheckItem({ ...checkItem, [name]: check });
  };

  React.useEffect(() => {
    setDisplayTable(
      Object.values(checkItem).filter(i => i === false).length > 1
    );
  }, [checkItem]);

  return (
    <>
      <div className={`${classes.SidebarMenuDetails}__table`}>
        {items.map((item, index) => (
          <div key={index} className={`${classes.SidebarMenuDetails}__list`}>
            <div
              key={item.name}
              className={`${classes.SidebarMenuDetails}__list__item ${
                checkItem[item.name] ? 'active' : ''
              }`}
              onClick={() => toggleCheck(item.name, !checkItem[item.name])}
              aria-hidden="true"
            >
              <div
                className={`${classes.SidebarMenuDetails}__list__item__icon`}
              >
                {item.icon}
              </div>
              <span
                className={`${classes.SidebarMenuDetails}__list__item__text`}
              >
                {subtitles[`${item.name}_`]}
              </span>
            </div>
          </div>
        ))}
      </div>
      {!displayTable ? <USpaceTable checkItem={checkItem} /> : null}
    </>
  );
};

export default SidebarMenuUSpaceDetails;
